import React from 'react';
import DefaultPagination from '../../../components/material-ui/pagination/DefaultPagination';

export default function HisMailingPagination({
  onFindClick,
  pageSize,
  pageNo,
  pageCount,
  setPageNo,
  setPageSize
}) {
  return (
    <DefaultPagination
      curPage={pageNo}
      pageCount={pageCount}
      selectRecord={pageSize}
      setCurPage={setPageNo}
      setSelectRecord={setPageSize}
      onFindClick={onFindClick}
    />
  );
}
